import { getMessageType } from './simulation/getMessageType.js';
import { simulateMessage } from './simulation/simulateMessage.js';
import { tryParsingSIWE } from './simulation/tryParsingSIWE.js';
export const createSimulateMessage = ({ apiEndpoint = 'https://simulation.a.exodus.io/simulateMessage', headers = {
    'X-Api-Version': '2023-06-05',
}, } = {}) => async ({ message, origin, asset, address, }) => {
    const simulationResult = {
        baseAssetName: asset.baseAssetName,
        action: 'NONE',
    };
    const messageType = getMessageType(message);
    if (messageType === 2 /* MessageTypeEnum.Unknown */) {
        return simulationResult;
    }
    tryParsingSIWE({
        message,
        messageType,
        origin,
        simulationResult,
    });
    await simulateMessage({
        address,
        message: {
            message,
            messageType,
        },
        origin,
        apiEndpoint,
        headers,
        simulationResult,
    });
    return simulationResult;
};
